<template>
  <svg width="29"
       height="30"
       viewBox="0 0 29 30"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_1242_5901)">
      <g clip-path="url(#clip0_1242_5901)">
        <rect x="26"
              y="1.5"
              width="23"
              height="23"
              rx="11.5"
              transform="rotate(90 26 1.5)"
              fill="#2B3C44" />
      </g>
      <rect x="25.5"
            y="2"
            width="22"
            height="22"
            rx="11"
            transform="rotate(90 25.5 2)"
            stroke="#2B3C44" />
    </g>
    <path
      d="M12 18.625L8.875 18.625L8.875 15.5M17 18.625L20.125 18.625L20.125 15.5"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M14.5 6.75L14.5 11.9375C14.4964 12.2704 14.5594 12.6007 14.6852 12.9089C14.811 13.2171 14.997 13.4971 15.2325 13.7325L20.125 18.625M12.625 14.875L8.875 18.625"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <defs>
      <filter id="filter0_d_1242_5901"
              x="0"
              y="0.5"
              width="29"
              height="29"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.352941 0 0 0 0 0.87451 0 0 0 0 0.654902 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1242_5901" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1242_5901" result="shape" />
      </filter>
      <clipPath id="clip0_1242_5901">
        <rect x="26"
              y="1.5"
              width="23"
              height="23"
              rx="11.5"
              transform="rotate(90 26 1.5)"
              fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {}
}
</script>
<svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">

  </svg>
